import React from "react";
import { FaAnglesRight } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaClock } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { FaSquareFacebook } from "react-icons/fa6";
import { FaSquareTwitter } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa6";

const Footer = () => {
  const Links = ({ Icon, info }) => {
    return (
      <div className="flex align-items-center gap-2 cursor-pointer">
        <Icon />
        <p>{info}</p>
      </div>
    );
  };
  return (
    <div className="flex flex-column flex-wrap ">
      <div className="flex flex-wrap text-white justify-content-between bg-black p-5">
        <div className=" md:w-3">
          <h4> About Us</h4>
          <p className="text-sm">
            Shah Transport was incorporated in 2004 with the aim to consolidate
            transportation services at one point and provide the best Customer
            Service.
          </p>
          <div className="flex gap-4 text-5xl cursor-pointer">
            <FaSquareFacebook />
            <FaSquareTwitter />
            <FaLinkedin />
          </div>
        </div>
        <div className="">
          <h4>Our Services</h4>
          <small>
            <Links Icon={FaAnglesRight} info="Reefer Freight" />
            <Links Icon={FaAnglesRight} info="General Freight" />
            <Links Icon={FaAnglesRight} info="Expedited Shipments" />
            <Links Icon={FaAnglesRight} info="Fast Certified" />
            <Links Icon={FaAnglesRight} info="Bondeed Carrier" />
          </small>
        </div>
        <div className="">
          <h4>Quick Links</h4>
          <small>
            <Links Icon={FaAnglesRight} info="About Us" />
            <Links Icon={FaAnglesRight} info="Services" />
            <Links Icon={FaAnglesRight} info="Careers" />
            <Links Icon={FaAnglesRight} info="Request A Quote" />
            <Links Icon={FaAnglesRight} info="Contact Us" />
          </small>
        </div>
        <div className="md:w-3">
          <h4>Get in Touch</h4>
          <small>
            <Links Icon={FaPhoneAlt} info="(905)-216-3424" />
            <Links Icon={MdEmail} info="dispatch@shahtransport.com" />
            <Links Icon={FaClock} info="Mon- Sat : 07:00 AM - 07:00 PM" />
            <Links
              Icon={FaLocationDot}
              info="Office : 5758 Dixie Rd, Mississauga
ON L4W 1E7"
            />
            <Links
              Icon={MdEmail}
              info="Mailing : 23 Alamosa Crt, Brampton
ON L6Y 2Z3"
            />
          </small>
        </div>
      </div>
      <div className="flex align-items-center justify-content-between text-white bg-blue p-4 px-6">
        <small></small>
        <small>2018 © All Rights Reserved by Shah Transport Limited</small>
        <small>CTPAT, IT and Training Partner : MAZE Consultancy.</small>
        <small></small>
      </div>
    </div>
  );
};

export default Footer;
